module.exports = __webpack_public_path__ + "img/masscoms_5.2a70882b.png";